export default function ParseBooking(time, message1 , message2){
    let startMessage = message1 || '';
    let endMessage = message2 || '';
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const parsedStart = Date.parse(time.start);
    const parsedEnd = Date.parse(time.end);
    const start = new Date(parsedStart);
    const end = new Date(parsedEnd);
    const date = days[start.getDay()] + ', ' + months[start.getMonth()] + ' ' + start.getDate(); 
    const startTime = start.getHours() + ':' + (start.getMinutes()<10?'0':'') + start.getMinutes();
    const endTime = end.getHours() + ':' + (end.getMinutes()<10?'0':'') + end.getMinutes();
    return startMessage + date + ' ' + startTime + '-' + endTime + endMessage;
}